/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CellPresenterBase } from "./CellPresenterBase";
import { ContentCellModelHelper } from "./ContentCellModelHelper";
import { FontUtil } from "igniteui-react-core";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var SummaryCellPresenter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SummaryCellPresenter, _super);
    function SummaryCellPresenter(a) {
        return _super.call(this, a) || this;
    }
    Object.defineProperty(SummaryCellPresenter.prototype, "d", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    SummaryCellPresenter.prototype.b = function (a) {
        _super.prototype.b.call(this, a);
        var b = a;
        if (a.ar) {
            ContentCellModelHelper.a(this.a.w, b, this.a.z, this.d.b6, this.a);
            ContentCellModelHelper.a(this.a.w, b, this.a.z, this.d.b7, this.a);
            if (a.av("ResolvedSummaryLabel") || a.av("ResolvedSummaryValue")) {
                if (b.kn != null) {
                    this.d.b6.setRawText(b.kn);
                }
                if (b.kp != null) {
                    this.d.b7.setRawText(b.kp);
                }
            }
            if (a.av("SummaryLabelTextColor")) {
                this.d.b6.setRawStyleProperty("color", b.ku._fill);
            }
            if (a.av("SummaryLabelFontInfo")) {
                var c = b.kg;
                if (c == null) {
                    c = FontUtil.getDefaultFont(this.a.w);
                }
                this.d.b6.setRawStyleProperty("font", c.fontString);
            }
        }
    };
    SummaryCellPresenter.$t = markType(SummaryCellPresenter, 'SummaryCellPresenter', CellPresenterBase.$);
    return SummaryCellPresenter;
}(CellPresenterBase));
export { SummaryCellPresenter };
//# sourceMappingURL=SummaryCellPresenter.js.map
